import PhoneIcon from '@mui/icons-material/Phone';
import { Button } from '@mui/material';
import { useMemo } from 'react';
import { Contact } from '../../sic-lib/types/Contact';
import { startCall, useDialerIsReady } from '../../store/dialer';
import { useAppDispatch } from '../../store/hooks';
import { useUserHasDialerSetup } from '../../store/users';

interface Props {
    contact: Contact;
    callNumber: string;
}

export default function ContactCallControls({ contact, callNumber }: Props) {
    const dispatch = useAppDispatch();

    const hasDialerSetup = useUserHasDialerSetup();
    const dialerIsReady = useDialerIsReady();

    //looks big, but simply:
    // checks the dialer is setup and pointed at sic
    // checks the twilio device is registered and not already in a call
    // checks the contact has sms and express/implied consent
    const canCall = useMemo(
        () =>
            hasDialerSetup &&
            dialerIsReady &&
            contact.consent?.smsConsent &&
            (contact.consent?.expressConsent || contact.consent?.impliedConsent),
        [hasDialerSetup, dialerIsReady, contact],
    );

    const handleMakeCall = () => {
        dispatch(
            startCall({
                phoneNumber: callNumber,
                contactId: contact.contactId,
                firstName: contact.firstName || '',
                lastName: contact.lastName || '',
            }),
        );
    };

    if (!canCall) return null;

    return (
        <Button
            onClick={handleMakeCall}
            variant="outlined"
            color="success"
            startIcon={<PhoneIcon />}
        >
            Call
        </Button>
    );
}
